<!--
  Copyright 2025 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div class="share-buttons">
  <button mat-stroked-button (click)="copyLinkToClipboard()">
    <mat-icon>link_24px</mat-icon>

    <span i18n="@@app.labels.copyLink">Copy link</span>
  </button>

  <button mat-stroked-button (click)="showQrCode()">
    <mat-icon>qr_code_2_24px</mat-icon>

    <span i18n="@@app.labels.showQrCode">Show QR code</span>
  </button>
</div>
